import "./loadingpage.scss";
import Loader from "components/Loading/Loader/Loader";

const LoadingPage = () => {

    return (
        <div className="main">
            <div className="container">
                <Loader/>
            </div>
        </div>
    );

};

export default LoadingPage;